import React, { ReactNode } from 'react';

interface TimegridCalendarLineHeaderProps {
  lineName: string;
  offset: number;
  onClick?: () => void;
  checkboxComponent?: ReactNode;
}

export const TimegridCalendarLineHeader: React.FC<TimegridCalendarLineHeaderProps> = ( {
  lineName,
  offset,
  onClick,
  checkboxComponent
} ) => {
  return (
    <div className={ 'h-full ' + ( onClick ? 'cursor-pointer' : '' ) } style={{ gridColumn: `span ${offset}` }} onClick={onClick ? onClick : () => { /** */ }}>
      <div className="h-full pt-1 relative overflow-y-hidden">

        <div className="items-center flex gap-2 w-full pl-2">
          { checkboxComponent }
          <h6
            className="text-xm font-medium text-gray-900 truncate"
            style={{ maxWidth: 180, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            title={lineName}
          >
            {lineName}
          </h6>
        </div>
      </div>
    </div>
  );
};
